<div class="profile" *ngIf="user">
	<div class="profile-header">
		<span class="my-account" (click)="goToAccount()">{{ 'app.account' | translate }}</span>
	</div>
	<div class="profile-image" (click)="goToAccount()">
		<img [src]="user.profileImage">
		<span class="payment-icon" *ngIf="mandateActive">
			<fa-icon matSuffix [icon]="['fas', 'bell']"></fa-icon>
		</span>
	</div>
</div>

<div class="login" *ngIf="!user">
	<div class="profile-header">
		<span class="my-login" (click)="goToLogin()">{{ 'app.login' | translate }}</span>
	</div>
</div>